// NOTE: Statsig event name is limited to 64 characters!
export const enum StatsigEventType {
  // NOTE: Core events
  // Those events are logged from multiple subpages with source metadata parameter
  CorePaxModalOpened = 'core_pax_modal_opened',
  CorePaxUpdated = 'core_pax_updated',
  CoreDateChanged = 'core_date_changed',
  NoAvailForMonth = 'no_avail_for_month',
  CoreNightsSelectorOpened = 'core_nights_selector_opened',
  CoreDateSelectedAtLeastOneYearAhead = 'core_date_selected_at_least_one_year_ahead',
  CoreTripAutoSavedAttempt = 'core_trip_auto_saved_attempt',

  // NOTE: Build your trip
  BuildYourTripInitiated = 'build_your_trip_initiated',

  // NOTE: Helper events for experiments, remove when not needed anymore
  TripOverviewMobileMainSummaryActionClicked = 'trip_overview_mobile_main_summary_action_clicked',

  // NOTE: Trip overview
  TripOverviewInitiated = 'overview_initiated',
  TripOverviewMobileControlCenterToggled = 'overview_mobile_control_center_toggled',
  TripOverviewAccommodationSelectorOpened = 'overview_accommodation_selector_opened',
  TripOverviewAddDestinationClicked = 'overview_add_destination_clicked',
  TripOverviewBookClicked = 'overview_book_clicked',
  TripOverviewBookClickedWithFarAirport = 'overview_book_clicked_with_far_airport',
  TripOverviewWarningModalDisplayed = 'overview_warning_modal_displayed',
  TripOverviewWarningModalClosed = 'overview_warning_modal_closed',
  TripOverviewWarningModalContinued = 'overview_warning_modal_continued',
  TripOverviewCheckoutRedirect = 'overview_checkout_redirect',
  OverviewCheckoutBasketError = 'overview_checkout_basket_error',
  OverviewCheckoutTokenError = 'overview_checkout_token_error',
  OverviewCheckoutUnknownError = 'overview_checkout_unknown_error',
  TripOverviewHotelChangeClicked = 'overview_hotel_change_clicked',
  TripOverviewTransportSelectorOpened = 'overview_transport_selector_opened',
  TripOverviewExploreActivitiesClicked = 'overview_explore_activities_clicked',
  TripOverviewActivityBannerElementClicked = 'overview_activity_banner_element_clicked',
  TripOverviewHotelToggle = 'overview_hotel_toggle',
  TripOverviewEditTripModalOpened = 'overview_edit_trip_modal_opened',
  TripOverviewEditTripModalDestinationAdded = 'overview_edit_trip_modal_destination_added',
  TripOverviewEditTripModalDestinationChanged = 'overview_edit_trip_modal_destination_changed',
  TripOverviewEditTripModalDestinationRearranged = 'overview_edit_trip_modal_destination_rearranged',
  TripOverviewFlyFromButtonClicked = 'overview_fly_from_button_clicked',
  TripOverviewUnavailableProductActionClicked = 'overview_unavailable_product_action_clicked',
  TripOverviewUnavailableProductRendered = 'overview_unavailable_product_rendered',
  TripOverviewAlternativeStaySelected = 'overview_alternative_stay_selected',
  TripOverviewAlternativeActivitySelected = 'overview_alternative_activity_selected',
  TripOverviewSeeAlternativeRoomsWhenNoAvail = 'overview_see_alternative_rooms_when_no_avail',
  TripOverviewChangeDateClicked = 'overview_change_date_clicked',
  TripOverviewConfirmAlternativeRoomSuggestionWhenNoAvail = 'overview_confirm_alternative_room_suggestion_when_no_avail',
  TripOverviewSeeAlternativeTicketsWhenNoAvail = 'overview_see_alternative_tickets_when_no_avail',
  TripOverviewAlternativeRoomsDisplayed = 'overview_alternative_rooms_displayed',
  TripOverviewAlternativeTicketsDisplayed = 'overview_alternative_tickets_displayed',
  TripOverviewAlternativeFlightSelected = 'overview_alternative_flight_selected',
  TripOverviewAlternativeFlightDisplayed = 'overview_alternative_flight_displayed',
  TripOverviewAlternativeFerrySelected = 'overview_alternative_ferry_selected',
  TripOverviewAlternativeFerryDisplayed = 'overview_alternative_ferry_displayed',
  TripOverviewHeaderActionClicked = 'overview_header_action_clicked',
  TripOverviewAlternativeAccommodationGalleryImageSwipe = 'overview_alternative_accommodation_gallery_image_swipe',
  TripOverviewActivityGalleryImageSwipe = 'overview_activity_gallery_image_swipe',
  TripOverviewAlternativeActivityGalleryImageSwipe = 'overview_alternative_activity_gallery_image_swipe',
  TripOverviewContinueWithSelectedDateModalOpened = 'overview_continue_with_selected_date_opened',
  TripOverviewEditRoomClicked = 'overview_edit_room_clicked',
  TripOverviewActivityRemoved = 'overview_activity_removed',
  TripOverviewFlightAdded = 'overview_flight_added',
  TripOverviewFlightRemoved = 'overview_flight_removed',
  TripOverviewFerryAdded = 'overview_ferry_added',
  TripOverviewFerryRemoved = 'overview_ferry_removed',
  TripOverviewTransportTicketTypeSelected = 'overview_transport_ticket_type_selected',
  TripOverviewFerryTicketUpsellSamePriceHidden = 'overview_ferry_ticket_upsell_same_price_hidden',
  TripOverviewFlightChangeClicked = 'overview_flight_change_clicked',
  TripOverviewFerryChangeClicked = 'overview_ferry_change_clicked',
  TripOverviewActivityChangeClicked = 'overview_activity_change_clicked',
  TripOverviewFlightShowDetailsClicked = 'overview_flight_show_details_clicked',
  TripOverviewFerryShowDetailsClicked = 'overview_ferry_show_details_clicked',
  TripOverviewHotelShowDetailsClicked = 'overview_hotel_show_details_clicked',
  TripOverviewActivityShowDetailsClicked = 'overview_activity_show_details_clicked',
  TripOverviewActivityEditFiltersClicked = 'overview_activity_edit_filters_clicked',
  TripOverviewFerryEditFiltersClicked = 'overview_ferry_edit_filters_clicked',
  TripOverviewActivityTryAnotherDateClicked = 'overview_activity_try_another_date_clicked',
  TripOverviewFerryTryAnotherDateClicked = 'overview_ferry_try_another_date_clicked',
  TripOverviewFerryChangePortsClicked = 'overview_ferry_change_airports_clicked',
  TripOverviewFlightChangeAirportsClicked = 'overview_flight_change_airports_clicked',
  TripOverviewShareOrSaveButtonClicked = 'overview_share_or_save_button_clicked',
  TripOverviewTripSummaryPanelOpened = 'overview_trip_summary_panel_opened',
  TripOverviewGlobalSuggestionSwitched = 'overview_global_suggestion_switched',
  TripOverviewSeeAllHotelsClicked = 'see_all_hotels_clicked',
  TripOverviewRemoveDestination = 'overview_remove_destination',
  TripOverviewConfigurationPanelOpened = 'overview_configuration_panel_opened',
  TripOverviewReloadPageModalOpened = 'trip_overview_reload_page_modal_opened',
  TripOverviewReloadPageButtonClicked = 'trip_overview_reload_page_button_clicked',
  TripOverviewReloadPageFailed = 'trip_overview_reload_failed',
  TripOverviewReloadPageSuccess = 'trip_overview_reload_success',
  TripOverviewAccommodationUpsellHotelAdded = 'overview_accommodation_upsell_hotel_added',
  TripOverviewScrollToSummary = 'overview_scroll_to_summary',
  TripOverviewPayLaterModalOpened = 'overview_pay_later_modal_opened',
  TripOverviewTravellingWithSemboModalOpened = 'overview_travelling_with_sembo_modal_opened',

  // NOTE: Hotel selection
  HotelSelectionInitiated = 'hotel_selection_initiated',
  HotelSelectionFilterOpened = 'hotel_selection_filter_opened',
  HotelSelectionFilterClosed = 'hotel_selection_filter_closed',
  HotelSelectionFilterApplied = 'hotel_selection_filter_applied',
  HotelSelectionFilterRemoved = 'hotel_selection_filter_removed',
  HotelSelectionFilterReset = 'hotel_selection_filter_reset',
  HotelSelectionMapMarkerClicked = 'hotel_selection_map_marker_clicked',
  HotelSelectionListCardClicked = 'hotel_selection_list_card_clicked',
  HotelSelectionMapCardClicked = 'hotel_selection_map_card_clicked',
  HotelSelectionBackButtonClicked = 'hotel_selection_back_button_clicked',
  HotelSelectionPeekPriceModalOpened = 'hotel_selection_peek_price_modal_opened',
  HotelSelectionPeekPriceModalDateSelected = 'hotel_selection_peek_price_modal_date_selected',
  HotelSelectionPeekPriceModalMonthSelected = 'hotel_selection_peek_price_modal_month_selected',
  HotelSelectionExtendMap = 'hotel_selection_extend_map',
  HotelSelectionCollapseMap = 'hotel_selection_collapse_map',
  HotelSelectionToggleView = 'hotel_selection_toggle_view',
  HotelSelectionToggleMapType = 'hotel_selection_toggle_map_type',
  HotelSelectionNoResultsResetClicked = 'hotel_selection_no_results_reset_clicked',
  HotelSelectionSearchThisAreaClicked = 'hotel_selection_search_this_area_clicked',
  HotelSelectionMapClusterClicked = 'hotel_selection_map_cluster_clicked',
  HotelSelectionUpsellBannerDisplayed = 'hotel_selection_upsell_banner_displayed',
  HotelSelectionUpsellBannerToggled = 'hotel_selection_upsell_banner_toggled',
  HotelSelectionSuggestionTypeSelected = 'hotel_selection_suggestion_type_selected',

  // NOTE: Hotel details
  // Those events are logged from multiple subpages with source metadata parameter
  HotelDetailsInitiated = 'hotel_details_initiated',
  HotelDetailsSelected = 'hotel_details_selected',
  HotelDetailsDeselected = 'hotel_details_deselected',
  HotelDetailsStaySelected = 'hotel_details_stay_selected',
  HotelDetailsShowStaysButtonClicked = 'hotel_details_show_stays_button_clicked',
  HotelDetailsContinueWithSelectedRooms = 'hotel_details_continue_with_selected_rooms',

  // NOTE: Activity selection
  ActivitySelectionInitiated = 'activity_selection_initiated',
  ActivitySelectionGalleryImageSwipe = 'activity_selection_gellery_image_swipe',
  ActivitySelectionFilterOpened = 'activity_selection_filter_opened',
  ActivitySelectionMapMarkerClicked = 'activity_selection_map_marker_clicked',
  ActivitySelectionListCardClicked = 'activity_selection_list_card_clicked',
  ActivitySelectionMapCardClicked = 'activity_selection_map_card_clicked',

  // NOTE: Activity details
  ActivityDetailsInitiated = 'activity_details_initiated',
  ActivityDetailsTicketSelected = 'activity_details_ticket_selected',
  ActivityDetailsOpenTicketsSelector = 'activity_details_open_tickets_selector',

  // NOTE: Flights list
  FlightListInitiated = 'flight_list_initiated',
  FlightListProductSelected = 'flight_list_product_selected',
  FlightListProductDeselected = 'flight_list_product_deselected',
  FlightListFilterModalOpened = 'flight_list_filter_modal_opened',
  FlightListFilterApplied = 'flight_list_filter_applied',
  FlightListViewTripClicked = 'flight_list_view_trip_clicked',
  FlightListEditModalOpened = 'flight_list_edit_modal_opened',
  FlightListNightsChanged = 'flight_list_nights_changed',

  // NOTE: Ferry list
  FerryListInitiated = 'ferry_list_initiated',
  FerryListProductSelected = 'ferry_list_product_selected',

  // NOTE: External errors
  ExternalErrorDisplayed = 'external_error_displayed',
  BookingFailedErrorTryAgain = 'booking_failed_error_try_again',
  BookingFailedErrorBuildNewTrip = 'booking_failed_error_build_new_trip',
  TransportStaticInfoNotAvailable = 'transport_static_info_not_available',

  // NOTE: Telemetry
  MissingAmenityConfiguration = 'telemetry_missing_amenity_configuration',
  TripOverviewInfiniteLoad = 'trip_overview_infinite_load',
  TripOverviewInfiniteLoadMissingAvailability = 'trip_overview_infinite_load_missing_availability',
  TripOverviewInfiniteLoadMissingStaticInfo = 'trip_overview_infinite_load_missing_static_info',
  HotelSelectionInfiniteLoad = 'hotel_selection_infinite_load',
  MetaHotelListEmpty = 'telemetry_meta_hotel_list_empty',
  MissingCarrierLogo = 'telemetry_missing_carrier_logo',
  HotelSelectionWithWrongIndexAccessed = 'telemetry_hotel_selection_with_wrong_index_accessed',
  HotelSelectionWithOldIndexAccessed = 'telemetry_hotel_selection_with_old_index_accessed',
  ActivitySelectionWithWrongIndexAccessed = 'telemetry_activity_selection_with_wrong_index_accessed',
  ActivitySelectionWithOldIndexAccessed = 'telemetry_activity_selection_with_old_index_accessed',

  // NOTE: Car planner
  CarPlannerInitialized = 'car_planner_initialized',
  CarPlannerShowSuggestedTrip = 'car_planner_show_suggested_trip',

  // NOTE: Print mode
  TripOverviewPrintModeOpened = 'trip_overview_print_mode_opened',
}
